/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Icsrm_Male9Inputs */

const en__field_enum_icsrm_male9 = /** @type {(inputs: _Field_Enum_Icsrm_Male9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`male`)
};

const de__field_enum_icsrm_male9 = /** @type {(inputs: _Field_Enum_Icsrm_Male9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`männlich`)
};

/**
* | output |
* | --- |
* | "male" |
*
* @param {_Field_Enum_Icsrm_Male9Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_icsrm_male9 = /** @type {((inputs?: _Field_Enum_Icsrm_Male9Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Icsrm_Male9Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_icsrm_male9(inputs)
	return de__field_enum_icsrm_male9(inputs)
});
export { _field_enum_icsrm_male9 as "_field_enum_ICSRM_MALE" }